export function SaveUserHistory(this: any, displayName: string) {
	const { comment, id: userId } = this;
	return {
		userId,
		displayName,
		comment,
	};
}
